import { PropsWithChildren, ReactNode } from "react";
import { Container } from "./Container";
import { cn } from "@/utils/tailwind";

interface Props extends PropsWithChildren {
  /**
   * If true, the `HeaderContainer` is sticky with the `Header`
   * @default false
   */
  sticky?: boolean;
  /**
   * If provided, renders a sticky sub-section below the header
   * with the gradient background and border.
   * If absent, the gradient and border are applied to the header itself.
   */
  subSection?: ReactNode;
}

export function HeaderContainer({
  sticky = false,
  subSection,
  ...props
}: Readonly<Props>) {
  const hasSubSection = !!subSection;

  return (
    <>
      <div
        className={cn(
          "flex flex-col items-start",
          !hasSubSection &&
            "bg-linear-to-b from-white to-grey-25 border-b border-grey-100 mb-10",
          hasSubSection && "bg-white",
          sticky && "sticky top-16 z-50",
        )}
      >
        <Container>{props.children}</Container>
      </div>

      {hasSubSection && (
        <div className="sticky top-16 z-40 bg-linear-to-b from-white to-grey-25 border-b border-grey-100 mb-10 pt-4">
          <Container>{subSection}</Container>
        </div>
      )}
    </>
  );
}
